export default __webpack_public_path__ + "static/media/廖婉君.e6437f5a.png";